import { render, staticRenderFns } from "./useragreement.vue?vue&type=template&id=37ee423e&scoped=true&"
import script from "./useragreement.vue?vue&type=script&lang=js&"
export * from "./useragreement.vue?vue&type=script&lang=js&"
import style0 from "./useragreement.vue?vue&type=style&index=0&id=37ee423e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ee423e",
  null
  
)

export default component.exports